import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import useUserStore from "../../../../utils/storeApp";
import CallAPI from "../../../../services/apiCalls";
import { Column } from "primereact/column";
import $ from "jquery";
import { Tag } from "primereact/tag";
import { useReactToPrint } from "react-to-print";
import ReportsDropdown from "../ReportsDropdown";
import { CSVLink } from "react-csv";
import SharedMsg from "../../SharedMsg";

const ListUserStatus = () => {
  const navigate = useNavigate();
  const { userRole, userToken, sharedObject, SetSharedObject } = useUserStore(
    (state) => ({
      userRole: state.userRole,
      userToken: state.userToken,
      sharedObject: state.sharedObject,
      SetSharedObject: state.SetSharedObject,
    })
  );
  const [userObj, setUserObj] = useState([]);
  const [count, setCount] = useState(0);
  const [refreshObj, SetRefreshObj] = useState(false);
  const [processing, SetProcessing] = useState(false);

  useEffect(() => {
    let obj = sharedObject.UserActiviySearch;
    if (obj && Object.keys(obj).length > 0) {
      setLast(obj.count < 25 ? obj.count : 25);
      gridData(obj);
    }
  }, [sharedObject.UserActiviySearch]);

  const getReport = async (src, pg) => {
    SetProcessing(true);
    let call =
      "/reports/UserStatus?searchPhrase=''&sortDir=userNameDisplay&sortBy=userNameDisplay&current=" +
      pg;
    SetRefreshObj(src);
    const res = await CallAPI(call, src, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      gridData(res.data.data);
      SetProcessing(false);
    } else {
      SetProcessing(false);
    }
  };
  const gridData = (obj) => {
    let cnt = obj.count;
    setCount(cnt);
    let tempObj = [];
    for (const row of obj.pageItems) {
      tempObj.push(row);
    }
    setUserObj(tempObj);
  };

  const deletedDate = (dt) => {
    return dt.dateModified
      ? new Date(dt.dateModified).toLocaleString("en-US", { hour12: false })
      : null;
  };
  const [first, setFirst] = useState(1);
  const [last, setLast] = useState(25);
  const [rows, setRows] = useState(25);
  const onPageChange = (event) => {
    setFirst(event.first + 1);
    setRows(event.rows);
    let lastNr = event.first + 25;
    let last = lastNr > count ? count : lastNr;
    setLast(last);
    let page = event.page + 1;
    SetRefreshObj(sharedObject.statusSearch);
    getReport(sharedObject.statusSearch, page);
  };
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const refreshPage = () => {
    setFirst(1);
    setLast(25);
    getReport(sharedObject.statusSearch, 1);
  };

  const bulkDownLoad = () => {
    SetSharedObject("UserActiviyStatus", "bulk");
    $("#userStatusSearchModal").modal("show");
  };
 
  const getSeverity = (product) => {
    switch (product.status) {
      case "Active":
        return "success";
      case "Pending":
        return "warning";
      case "IDP Failed and Locked":
        return "danger";
      case "Failed":
        return "danger";
      case "Locked":
        return "danger";
      default:
        return null;
    }
  };
  const imageBodyTemplate = (product) => {
    let s = <Tag value={product.status} severity={getSeverity(product)}></Tag>;
    return s;
  };
  const headers = [
    {
      label: "User Name",
      key: "userNameDisplay",
    },
    { label: "Account Name", key: "accountName" },
    { label: "Direct Email", key: "directMail" },
    { label: "Address", key: "address" },
    { label: "City", key: "city" },
    { label: "State", key: "state" },
    { label: "Zip", key: "zip" },
    { label: "Status", key: "status" },
    { label: "Last Modified", key: "dateModified" },
    { label: "Organization", key: "orgName" },
  ];

  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processing]);

  return (
      <main ref={componentRef} className="ListUserStatus">
        <header>
            <div className="spacer-inline sp-margin12">
                <h4 className="title-label3">
                User Status
            </h4>
          </div>
              <div className="mid-header-bar spacer-inline sp-mx5">
            <ReportsDropdown />
            <button
              className="btn btn-outline-dark sp-margin5 btn-reports-sm"
              data-toggle="modal"
              aria-label="Open user status search"
              aria-haspopup="dialog"
              onClick={(e) => {
                SetSharedObject("UserActiviyStatus", "reg");
                $("#userStatusSearchModal").modal("show");
              }}
            >
              <i className="bi bi-search" aria-hidden="true"></i>
            </button>
            <button
              className="btn btn-outline-dark sp-margin5 btn-reports-sm"
              aria-label="Open bulk download user status search"
              aria-haspopup="dialog"
              data-toggle="modal"
              onClick={(e) => {
                bulkDownLoad();
              }}
            >
              <i className="bi bi-box-arrow-down" aria-hidden="true"></i>
            </button>

            <div className="spacer-inline" role="toolbar" aria-label="User status report export and refresh tools">
                <span className="SharedTools" role="group" aria-label="Export and print tools">
                    {count > 0 ? (
                      <CSVLink
                        filename="ListUserStatus.csv"
                        className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                        aria-label="Download user status as MS Excel CSV file"
                        data={userObj}
                        headers={headers}
                      >
                        <i className="bi bi-download" aria-hidden="true"></i>
                      </CSVLink>
                    ) : (
                      <button
                            type="button"
                            className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                            disabled
                            aria-disabled="true"
                            aria-label="Download CSV (no results available)"
                          >
                            <i className="bi bi-download" aria-hidden="true"></i>
                       </button>
                    )}

                  <button
                    type="button"
                    className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                    disabled={count === 0} 
                    aria-disabled={count === 0}
                    aria-label={
                          count === 0
                            ? "Refresh report (no results to refresh)"
                            : "Refresh report"
                        }
                    onClick={(e) => {
                      if (count > 0) refreshPage();
                    }}
                  >
                    <i className="bi bi-arrow-clockwise" aria-hidden="true"
                    ></i>
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                    disabled={count === 0} 
                    aria-disabled={count === 0}
                    aria-label={
                      count === 0
                        ? "Print report (no results to print)"
                        : "Print received messages report"
                    }
                    onClick={(e) => {
                      if (count > 0) handlePrint();
                    }}
                  >
                    <i className="bi bi-printer" aria-hidden="true"></i>
                  </button>
                </span>
            </div>
          </div>
        </header>
      <div>
        <section className="grid-header-bar"  aria-label="Report filter summary">
          {userRole !== "SES ADMINISTRATOR" &&
          userRole !== "SYSTEMADMINISTRATOR" ? null : (
            <>
            <dl className="sp-mx7 ">
              <div className="spacer-inline spacer-margin1">
                <dt className="ft-wt">Domain:</dt>
                <dd className="sp-margin12  sp-mx7">
                  {sharedObject?.statusSearch?.DomainName
                    ? sharedObject?.statusSearch?.DomainName
                    : null}
                </dd>
              </div>
              <div className="spacer-inline">
                <dt className="ft-wt">Customer:</dt>
                <dd className="sp-margin12  sp-mx7">
                  {sharedObject?.statusSearch?.VendorName
                    ? sharedObject?.statusSearch?.VendorName
                    : null}
                </dd>
              </div>
            </dl>
            </>
          )}
          <SharedMsg />
        </section>
        <section className="grid-layout">
          {userObj?.length > 0 ? (
            <div id="SentMessageReport">
              <DataTable
                value={userObj}
                aria-label="User Status Report"
                rows={25}
                paginator
                selectionPageOnly
                rowsPerPageOptions={[25, 50, 75]}
                tableStyle={{ minWidth: "50rem" }}
                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                dataKey="Id"
                columnResizeMode="expand"
                resizableColumns
                scrollable
                sortField="userNameDisplay"
                sortOrder={-1}
              >
                <Column field="userNameDisplay" header="Username" className="print-col" sortable ></Column>
                <Column field="accountName" header="Account Name" className="print-col" sortable ></Column>
                <Column field="directMail" header="Direct Email" className="print-col" sortable ></Column>
                <Column field="address" header="Address" className="print-col" sortable ></Column>
                <Column field="city" header="City" className="w-md1" sortable ></Column>
                <Column field="state" header="State" className="w-sm" sortable ></Column>
                <Column field="zip" header="Zip" className="w-md4" sortable ></Column>
                <Column field="status" header="Status" className="w-md4" sortable body={imageBodyTemplate} ></Column>
                <Column field="dateModified" header="Last Modified" className="w-md7" sortable body={deletedDate} ></Column>
                <Column field="orgName" header="Organization" className="print-col" sortable ></Column>
              </DataTable>
            </div>
          ) : (
            <section className="empty-grid" role="status" aria-live="polite" aria-atomic="true">
              There are currently no search results.
            </section>
          )}
        </section>
       
        {processing && (
          <div 
            className="loader-container" 
            role="status" 
            aria-live="polite" 
            aria-atomic="true"
            aria-labelledby="user-status-loader"
          >
            <div className="spinner" aria-hidden="true"></div>
            <div className="loading-text" id="user-status-loader">{loadingText}</div>
        </div>
        )}
      </div>
    </main>
  );
};

export default ListUserStatus;
